<template>
  <div class="pa-park-note-comment-view-set">
    <PAParkNoteCommentFetchButton
     :isLoading="isLoadingFetchButton"
     @handleClick="handleClickFetchButton"
    />

    <PAParkNoteCommentView
     :commentList="commentList"
    />

    <PAParkNoteCommentEditor
     @submitComment="handleSubmitComment"
    />
  </div>
</template>

<script>
import PAParkNoteCommentFetchButton from '@/components/Pages/Parks/Note/PAParkNoteCommentFetchButton/PAParkNoteCommentFetchButton.vue'
import PAParkNoteCommentView from '@/components/Pages/Parks/Note/PAParkNoteCommentView/PAParkNoteCommentView.vue'
import PAParkNoteCommentEditor from '@/components/Pages/Parks/Note/PAParkNoteCommentEditor/PAParkNoteCommentEditor.vue'

import {GetParkNoteComment, GetParkNoteCommentList} from '@/graphql/queries/ParkNoteComment.graphql'

export default {
  props : {
    parkNoteId : {
      default: null
    }
  },
  
  components : {
    PAParkNoteCommentFetchButton,
    PAParkNoteCommentView,
    PAParkNoteCommentEditor,
  },

  data(){
    return {
      isLoadingFetchButton  : false,

      commentList           : [],

      page                  : 1,
      first                 : 10,
      lastPage              : null,
      total                 : null,
      loaded                : false,

      currentPage           : null,
      
      commentEditorText     : ''
    };
  },

  apollo : {
    parkNoteComments : {
      query : GetParkNoteCommentList,
      
      variables(){
        return {
          park_note_id  : this.parkNoteId,
          page          : this.page,
          first         : this.first,
          orderBy       : [
            {
              // field : 'created_at',
              column : 'created_at',
              order : 'DESC'
            }
          ]
        };
      },

      result(result){
        const apolloClient = this.$apollo.provider.defaultClient;

        for(let parkNoteComment of result.data.parkNoteComments.data){
          apolloClient.writeQuery({
            query     : GetParkNoteComment,
            variables : {
              id  : parkNoteComment.id
            },
            data      : {
              parkNoteComment : parkNoteComment
            }
          });
        }

        this.$store.dispatch({
          type        : 'parkNoteComment/updateParkNoteCommentData',
          loaded      : true
        });
      },

      skip(){
        return (this.page === null);
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      },

      fetchPolicy: 'no-cache'
    }
  },

  computed : {
    storedParkNoteId(){
      return this.$store.state.parkNoteComment.parkNoteId;
    },
    
    storedParkNoteComments(){
      return this.$store.state.parkNoteComment.parkNoteComments;
    }
  },

  watch : {
    storedParkNoteComments : {
      handler(){
        this.setParkNoteCommentListData();
      },
      immediate: true,
      deep:true
    },
    
    storedParkNoteId  : {
      handler(value){
        if(value === null) return;
        
        this.setParkNoteCommentListData();
      },
      immediate: true
    },

    parkNoteId  : {
      handler(value){
        if(typeof value === 'undefined') return;
        this.$store.dispatch({
          type        : 'parkNoteComment/updateParkNoteId',
          parkNoteId  : value
        });
      },
      immediate: true
    },

    parkNoteComments : {
      handler(data){
        if(typeof data === 'undefined') return;

        const listViewData = {
          list        : [],
          page        : null,
          lastPage    : null,
          total       : null
        };

        for(let parkNoteComment of data.data){
          listViewData.list.push({
            id  : parkNoteComment.id
          });
        }

        if(typeof data.paginatorInfo !== 'undefined'){
          listViewData.page     = data.paginatorInfo.currentPage;
          listViewData.lastPage = data.paginatorInfo.lastPage;
          listViewData.total    = data.paginatorInfo.total;
        }
        
        this.$store.dispatch({
          type        : 'parkNoteComment/updateParkNoteCommentData',
          parkNoteId  : this.parkNoteId,
          list        : listViewData.list,
          page        : listViewData.page,
          lastPage    : listViewData.lastPage,
          total       : listViewData.total
        });
      },
      immediate: true,
      deep: true
    }
  },

  methods : {
    setParkNoteCommentListData(){
      for(let i = 0; i < this.storedParkNoteComments.length; i++){
        if(this.storedParkNoteComments[i].parkNoteId === this.parkNoteId){
          this.commentList  = this.storedParkNoteComments[i].list;

          this.currentPage  = this.storedParkNoteComments[i].currentPage;

          this.page         = this.storedParkNoteComments[i].page;
          this.lastPage     = this.storedParkNoteComments[i].lastPage;
          this.total        = this.storedParkNoteComments[i].total;
          this.loaded       = this.storedParkNoteComments[i].loaded;
        }
      }
    },

    async handleClickFetchButton(){
      this.isLoadingFetchButton = true;

      await this.UXWaiting(500);

      if(!(this.page >= this.lastPage)){
        const nextPage = (this.currentPage + 1);

        this.$store.dispatch({
          type        : 'parkNoteComment/updateParkNoteCommentData',
          parkNoteId  : this.parkNoteId,
          behaviour   : 'prev',
          page        : nextPage,
          currentPage : nextPage
        });
      }

      this.isLoadingFetchButton = false;
    },

    async handleSubmitComment(){
      this.$store.dispatch({
        type        : 'parkNoteComment/updateParkNoteCommentData',
        parkNoteId  : this.parkNoteId,
        page        : null
      });

      await this.UXWaiting(100);

      this.$store.dispatch({
        type        : 'parkNoteComment/updateParkNoteCommentData',
        behaviour   : 'fetch',
        parkNoteId  : this.parkNoteId,
        page        : 1
      });
    }
  }
}
</script>